export const formatBankAccountNumber = (accountNumber: string) => accountNumber.slice(accountNumber.length - 4);
